import { styled } from '@mui/material';
import { TextFieldStyles } from 'v3/shared/components/Inputs/styles/InputFormStyles';

export const TextFieldStyled = styled(TextFieldStyles)(({ theme }) => ({
  color: theme.palette.common.white,
  input: {
    cursor: 'pointer',
    textOverflow: 'ellipsis',
  },
  svg: {
    color: theme.palette.common.white,
    cursor: 'pointer',
  },
}));
